requirejs.config({
    baseUrl: rootPath + '/App',
    paths: {
        'text': '../Scripts/text',
        'durandal': '../Scripts/durandal',
        'plugins': '../Scripts/durandal/plugins',
        'transitions': '../Scripts/durandal/transitions',
        'toastr': '../Scripts/toastr'
    }
});

define('jquery', [],function () { return jQuery; });
define('knockout', ko);
define('main',['durandal/system', 'durandal/app', 'durandal/viewLocator', 'services/appsecurity'], function (system, app, viewLocator, appsecurity) {
    system.debug(enableDebugMode);
    app.title = 'DERA';

    app.configurePlugins({
        router: true,
        dialog: true,
        widget: true
    });

    app.start().then(function () {
        //Replace 'viewmodels' in the moduleId with 'views' to locate the view.
        //Look for partial views in a 'views' folder in the root.
        viewLocator.useConvention();
        //Show the app by setting the root view model for our application with a transition.
        appsecurity.initializeAuth()
            .then(function (data) {
                app.setRoot('viewmodels/shell', 'entrance');
            });
    });
});
